<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      
      <el-form class="backborder1">
      	  <el-form-item style="width:100%">
      	  	  <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
			  <el-button type="success" size="small" icon="el-icon-upload2" @click="uploadinfos">上传文件</el-button>
			  <el-button type="primary" size="small" icon="el-icon-download" @click="downmodel">下载模板</el-button>
			  <el-button type="primary" size="small" icon="el-icon-tickets" @click="mygoodssupply" style="float:right">查看我的供应商</el-button>
			  <el-button type="primary" size="small" icon="el-icon-goods" @click="mygoodsbrand" style="float:right">查看我的品牌</el-button>
			  <el-button type="primary" size="small" icon="el-icon-menu" @click="mygoodscate" style="float:right">查看我的分类</el-button>      	  	  
      	  </el-form-item>
      </el-form>
      
      <el-tag type="danger" closable  @close="closetag" v-if="tagshow=='true'" style="margin-top:10px">温馨提示：该功能需要您点击下载宠老板代理端商品信息上传模板并认真填写商品信息，谢绝自定义模板</el-tag>
      
      <div class="backborder2" :style="csstop">
      	  <el-table :data="productsmore" v-loading="uploadgoodsLoading" style="width:100%;margin-top:20px">
		      <el-table-column prop="number" label="编号" align="left"></el-table-column>
		      <el-table-column prop="name" label="名称" align="left"></el-table-column>
		      <el-table-column prop="goodstype" label="商品类型" align="left"></el-table-column>
		      <el-table-column prop="basecode" label="基本条码" align="left"></el-table-column>
		      <el-table-column prop="costtype" label="成本算法" align="left"></el-table-column>
		      <el-table-column prop="validity" label="有效期（天）" align="center"></el-table-column>
		      <el-table-column prop="spec" label="规格" align="center"></el-table-column>
		      <el-table-column prop="catid" label="商品分类" align="left"></el-table-column>
		      <el-table-column prop="brandid" label="品牌" align="left"></el-table-column>
		      <el-table-column prop="supplierid" label="供应商" align="left"></el-table-column>
		      <el-table-column prop="unit" label="单位名称" align="center"></el-table-column>
		      <el-table-column prop="buy" label="进货价" align="center"></el-table-column>
		      <el-table-column prop="sell" label="批发价" align="center"></el-table-column>
		      <el-table-column prop="market" label="零售价" align="center"></el-table-column>	          
		      <el-table-column label="操作">
			      <template slot-scope="scope">
			          <el-button type="danger" size="mini" circle icon="el-icon-delete" @click="delinfos(scope.$index)"></el-button>
			      </template>
		      </el-table-column>
      	  </el-table>
      	  <div slot="footer" class="dialog-footer" style="text-align:right;margin-top:15px">
          	  <el-button size="small" type="primary" :loading="saveexcelLoading" @click="inputinfosSave">保 存</el-button>
      	  </div>
      </div>
      
      <!----------------------------- 我的供应商 ----------------------------------->
      <el-dialog title="我的供应商" :visible.sync="mysupplyDialog" top="5vh" width="50%">
          <el-table :data="mysupply" v-loading="mysupplyLoading" style="width:100%">
              <el-table-column label="名称" prop="apply_name"></el-table-column>
          </el-table>
          <!--分页begin-->
          <div class="block">
	          <el-pagination
	            @size-change="mysupplypageSizeChange"
	            @current-change="mysupplypageCurrentChange"
	            :current-page="mysupplyquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="mysupplyquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="my_supply_total_rows">
	          </el-pagination>
          </div>
          <!--分页end-->
      </el-dialog>
      
      <!------------------------ 我的品牌 ---------------------->
      <el-dialog title="我的品牌" :visible.sync="mybrandDialog" top="5vh" width="50%">
          <el-table :data="mybrand" v-loading="mybrandLoading" style="width:100%">
              <el-table-column label="名称" prop="name"></el-table-column>
          </el-table>
          <!--分页begin-->
          <div class="block">
	          <el-pagination
	            @size-change="mybrandpageSizeChange"
	            @current-change="mybrandpageCurrentChange"
	            :current-page="mybrandquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="mybrandquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="my_brand_total_rows">
	          </el-pagination>
          </div>
          <!--分页end-->
      </el-dialog>
      
      <!------------------------ 我的分类管理 ---------------------->
      <el-dialog title="我的商品分类" :visible.sync="myclassDialog" top="5vh" width="50%">
          <el-table :data="mycate" v-loading="myclassLoading" style="width:100%">
              <el-table-column label="名称" prop="catname"></el-table-column>
          </el-table>
          <!--分页begin-->
          <!--
          <div class="block">
	          <el-pagination
	            @size-change="mypageSizeChange"
	            @current-change="mypageCurrentChange"
	            :current-page="mycatequery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="mycatequery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="my_cate_total_rows">
	          </el-pagination>
          </div>
          -->
          <!--分页end-->
      </el-dialog>
      
      
      
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作功能权限
      url:this.GLOBAL.domain+"Product/index",
      transitionshow:true,
      mysupplyDialog:false,
      mysupplyLoading:false,
      mysupplyquery:{
      	url:this.GLOBAL.domain+"Product/index",
        act:'getapplylists',
        token:this.$cookies.get('token'),
        rollpage: 10, // 页大小
        p: 1
      },
      mysupply:[],
      my_supply_total_rows: 0,
      mybrandDialog:false,
      mybrandLoading:false,
      mybrandquery:{
      	url:this.GLOBAL.domain+"Brand/index",
        act:'lists',
        token:this.$cookies.get('token'),
        rollpage: 10, // 页大小
        p: 1
      },
      mybrand:[],
      my_brand_total_rows: 0,
      myclassDialog:false,
      myclassLoading:false,
      mycate:[],
      my_cate_total_rows:0,
      mycatequery:{
      	url:this.GLOBAL.domain+"Product/index",
        act:'getmycate',
        token:this.$cookies.get('token'),
        rollpage: 10, // 页大小
        p: 1
      },
      my_cate_total_rows:0,
      productsmore:[],
      uploadgoodsLoading:false,
      saveexcelLoading: false,
      uploadgoodsLoading:false,
      tagshow:'true',
      csstop:{'margin-top':'10px'},
      
    }
  },
  mounted(){
  	this.getactionauth();
  },
  methods:{
  	
  	/** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /** 获取我的商品供应商信息列表 **/
    mygoodssupply() {
    	this.mysupplyDialog=true;
    	this.mysupplyLoading=true;
        var resource = this.$resource(this.mysupplyquery.url);
        resource.query(this.mysupplyquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.mysupplyDialog=false;
    			this.mysupplyLoading=false;
	        }else{
	            this.mysupply = JSON.parse(Base64.decode(res.data.Data));
	            this.my_supply_total_rows=parseInt(res.data.count);
    		    this.mysupplyLoading=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
    		this.mysupplyLoading=false;
        });
    },
    mysupplypageSizeChange(val) {
    	this.mysupplyquery.rollpage = val;
        this.mygoodssupply();
    },
    mysupplypageCurrentChange(val) {
        this.mysupplyquery.p = val;
        this.mygoodssupply();
    },
  	
  	/** 获取我的商品品牌列表 **/
    mygoodsbrand() {
    	this.mybrandDialog=true;
    	this.mybrandLoading=true;
        var resource = this.$resource(this.mybrandquery.url);
        resource.query(this.mybrandquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.mybrandDialog=false;
    		    this.mybrandLoading=false;
	        }else{
	            this.mybrand = JSON.parse(Base64.decode(res.data.Data));
	            this.my_brand_total_rows=parseInt(res.data.count);
    		    this.mybrandLoading=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
    		this.mybrandLoading=false;
        });
    },    
    mybrandpageSizeChange (val) {
        this.mybrandquery.rollpage = val;
        this.mygoodsbrand();
    },
    mybrandpageCurrentChange (val) {
        this.mybrandquery.p = val;
        this.mygoodsbrand();
    },
  	
  	/** 获取我的商品信息分类列表 **/
    mygoodscate() {
    	this.myclassDialog=true;
    	this.myclassLoading=true;
        var resource = this.$resource(this.mycatequery.url);
        resource.query(this.mycatequery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.myclassDialog=false;
    		    this.myclassLoading=false;
	        }else{
	            this.mycate = JSON.parse(Base64.decode(res.data.Data));
	            this.my_cate_total_rows=parseInt(res.data.count);
    		    this.myclassLoading=false;
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
    		this.myclassLoading=false;
        });
    },
    mypageSizeChange(val) {
        this.mycatequery.rollpage = val;
        this.mygoodscate();
    },
    mypageCurrentChange(val) {
        this.mycatequery.p = val;
        this.mygoodscate();
    },
    
    /** 批量新增商品 **/
    showSlmore() {
    	this.showSlmoreDialog=true;
    },
    
    /** 下载模板 **/
    downmodel() {
    	location.href=this.GLOBAL.domain+"ChangeFile/getexport";
    },
    
    /** 导入文件 **/
    uploadinfos() {
    	document.getElementById("fileupload").click();
    },
    
    /** 删除导入商品信息 **/
    delinfos(index) {
    	this.productsmore.splice(index,1);
    },
  	
  	/** 保存批量导入商品 **/
    inputinfosSave() {
    	this.saveexcelLoading=true;    	
        var resource = this.$resource(this.url);
        resource.save({act:'saveinputgoods',token:this.$cookies.get('token'),infos:this.productsmore}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.saveexcelLoading=false;
	        }else{
	            this.$message.success('商品信息导入成功！');
    		    this.saveexcelLoading=false;
    		    this.productsmore=[];
    		    
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
    		this.saveexcelLoading=false;
        });
    },
    
    /************** 导入excel表格数据 **************/
    importfile(obj) {    
    	let _this = this;
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file = event.currentTarget.files[0];                
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var outdata;
        var reader = new FileReader();
        FileReader.prototype.readAsBinaryString = function(f) {
        	var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西

                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;
                
                //提交数据到后台
                _this.uploadgoodsLoading=true;
        		var resource = _this.$resource(_this.url);
                resource.save({act:'inputinfos',infos:outdata,token:_this.$cookies.get('token')}).then((res) => {
                    if(res.data.Result>0){
                    	if(res.data.Result=='70001') this.$router.push('/login')
                    	_this.uploadgoodsLoading=false;
                    	_this.$message({
				    		dangerouslyUseHTMLString: true,
				    		type:'error',
				    		message:'<span style="line-height:20px">'+res.data.Message+'</span>',
			    		});
                    }else{
                    	_this.productsmore=JSON.parse(Base64.decode(res.data.Data));
                    	_this.uploadgoodsLoading=false;
                    	_this.$message.success('导入商品信息成功!');
                  	}
                }).catch((res) => {
                	_this.uploadgoodsLoading=false;
                    _this.$message.error(this.GLOBAL.errortext);
                });        
                           
            }
            reader.readAsArrayBuffer(f);
        }
               
        if(rABS) {
        	reader.readAsArrayBuffer(f);
        } else {
            reader.readAsBinaryString(f);
        }                 
    },
    
    closetag() {
    	this.tagshow='false';
    },
    
    
  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/inventory/Productaddmore.vue